import ForgotPassword from './ForgotPassword'

export default ForgotPassword
// eslint-disable-next-line import/export
export * from './ForgotPassword'
